/**
 * Staging 對接 diagnose 工具。預設關閉,opt-in 後印 console;所有環境(含部署後的
 * Cloud Run image)都能用 runtime toggle 開啟 — R126 拿掉舊 `import.meta.env.DEV`
 * early-return:production build 也是 DEBUG env 注入,gate 會把整條注入鏈咬死。
 *
 * Toggle 方式(任一條成立即啟用):
 * - `config.debug`(機制 A runtime config;dev 走 `.env.local` 的 `VITE_DEBUG`,
 *   部署環境走 nginx envsubst 的 `DEBUG`。重新啟動 dev server / 重新注入才生效)
 * - console 跑 `localStorage.setItem('JOBS_DEBUG', '1')` + reload(per-tab)
 *
 * Scope tag 規範:
 * - `boot` — services container 載入
 * - `csrf` — httpApiClient 設 `X-CSRF-Token` header 時
 * - `idem` — 設 `X-Idempotency-Key` 時(jobs submit/continue/cancel)
 * - `err` — httpRequestWithRefresh 非 2xx response
 * - `graph` — canvas graph 持久化 / catalog 估價 fallback 等 graph 相關診斷
 *   (R49 起 graph 走 dagService per-doc CRUD;`graphRepo` 已砍)
 * - `listener` — useJobListener handler 觸發 / mapping / store update(R41.1)
 * - `ui` — 等 BE endpoint 的頁面佔位動作(mock 按鈕點擊軌跡;R126 收 console.log 殘留)
 */

import { config } from '@/config';

export type DebugScope = 'boot' | 'csrf' | 'idem' | 'err' | 'graph' | 'listener' | 'ui';

function readToggle(): boolean {
  // 優先順序：config(runtime)> localStorage
  if (config.debug) {
    return true;
  }
  try {
    if (typeof localStorage !== 'undefined') {
      return localStorage.getItem('JOBS_DEBUG') === '1';
    }
  } catch {
    // localStorage 在某些 sandbox 環境（incognito 限制）會 throw — 安靜忽略
  }
  return false;
}

/**
 * 印 debug log；toggle 關時 noop（預設全關，任何環境 opt-in 才輸出）。
 */
export function debugLog(scope: DebugScope, ...args: unknown[]): void {
  if (!readToggle()) return;
  console.info(`[${scope}]`, ...args);
}
